"use client";

import React from "react";
import { CosmosTitle, CosmosButton } from "@cosmos/web/react";
import classnames from "classnames/bind";
import styles from "./QaSummary.module.css";
import { QaSummaryTabs } from "./QaSummary-tabs";
import { QaSummaryAccordion } from "./QaSummary-accordion";
import { useViewportDimensions } from "../../../helpers/useViewportDimensions";
import { useLocaleStringContext } from "../../../helpers/LocaleStringContext";
import { getFaqHomeUrl } from "../../../helpers/getFaqHomeUrl";
import template from "../../../helpers/template";
import { useTranslationsContext } from "../../../helpers/TranslationsContext";
import { usePathname } from "next/navigation";
import { FaqItem } from "./QaSummary.types";
import { analyticsClick } from "../../../helpers/analytics";

const cx = classnames.bind(styles);

export const QaSummary = ({
  title,
  faqItems,
}: {
  title: string | null;
  faqItems: FaqItem[];
}) => {
  const DESKTOP_BREAKPOINT = 1000;

  const { viewportWidth } = useViewportDimensions();

  const translations = useTranslationsContext();

  const localeString = useLocaleStringContext();
  const route = usePathname();
  const faqHomeUrl = getFaqHomeUrl(localeString, route ?? "");

  return (
    <div className={cx("container")}>
      <div className={cx("inner")}>
        <div className={cx("header")}>
          <CosmosTitle
            className={cx("heading")}
            size="x-large"
            appearance="dark"
            id="tablist-1"
            tag="h2"
          >
            {title}
          </CosmosTitle>
        </div>
        {faqItems && (
          <div className={cx("wrapper")}>
            {viewportWidth >= DESKTOP_BREAKPOINT ? (
              <QaSummaryTabs items={faqItems} />
            ) : (
              <QaSummaryAccordion items={faqItems} />
            )}
          </div>
        )}

        <div className={cx("button-wrapper")}>
          <CosmosButton
            className={cx("button")}
            kind="primary"
            size="large"
            href={faqHomeUrl}
            onClick={() => {
              analyticsClick({
                value: "See more FAQs",
                clickUrl: faqHomeUrl,
                elementPosition: "FAQ Section",
                method: "Outbound: FALSE",
                contentType: "Button Click",
              });
            }}
          >
            {template(
              translations["faqSummary.button.seeMoreFaqs"],
              "Read more questions",
            )}
          </CosmosButton>
        </div>
      </div>
    </div>
  );
};
